/**
Stable reference empty array, to be used in React components or hooks
that need to be stable across re-renders / effect runs.
For example, without it an inline `[]` in `selectFromResult` from RTK Query would
return a new `[]` on every store update, breaking the shallow-equality
*/
export const STABLE_ARRAY: never[] = [];
